
  import Formulario from './formulario'

  export default {
    name: 'consulta',
    components: { Formulario },
    data () {
            return {
                    slide: 'prorrogacao'
                    }
  }
  }


